import React from 'react';
import {twMerge} from 'tailwind-merge';

interface Props {
    id?: string;
    label?: string;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    dropdown?: boolean;
    options?: string[];
    dropdownDesc?: string;
    selectProps?: React.SelectHTMLAttributes<HTMLSelectElement>;
}

/**
 * @description Rendition Tailwind Styled Input
 */
export const Input = React.forwardRef<HTMLInputElement, Props>(
    ({label, id, inputProps, dropdownDesc, dropdown = false, options = [], selectProps}, ref) => {
        return (
            <div className={twMerge('relative', inputProps?.disabled && 'opacity-30')}>
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                    {label && <span className="text-[13px] font-semibold capitalize text-white">{label}</span>}
                </div>
                <input
                    {...inputProps}
                    id={id}
                    ref={ref}
                    className={twMerge(
                        'block h-5 w-full border-b-2 border-zinc-700 bg-transparent py-0.5',
                        label && 'pl-24 pr-7 text-right',
                        'text-base font-extrabold text-white outline-none transition-colors placeholder:text-gray-400 placeholder:opacity-20 focus:border-sky-500',
                        inputProps?.className
                    )}
                />
                {dropdown && (
                    <div className="absolute inset-y-0 right-0 flex items-center">
                        {dropdownDesc && (
                            <label htmlFor={selectProps?.id} className="sr-only">
                                {dropdownDesc}
                            </label>
                        )}
                        <select
                            {...selectProps}
                            className={twMerge(
                                'h-full cursor-pointer appearance-none bg-transparent py-0 pl-1 text-[10px] font-medium text-white',
                                selectProps?.className
                            )}
                        >
                            {options.map((option) => (
                                <option key={option}>{option}</option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
        );
    }
);
